module.exports = __webpack_public_path__ + "img/about_nineton.b96b797c.png";